import { Component, effect, input, viewChild, ViewChild } from '@angular/core';
import { MarkerComponent, PopupComponent } from '@maplibre/ngx-maplibre-gl';
import { applyMarkerOffset } from './marker-offset';

interface TrackerPosition {
  id: string;
  name: string;
  longitude: number;
  latitude: number;
  altitude?: number;
  color: string;
}

@Component({
  selector: 'lib-map-tracker-mobile-marker',
  standalone: true,
  imports: [MarkerComponent, PopupComponent],
  template: `
    <!--    <mgl-marker #markerElement [lngLat]="[trackerPosition().longitude, trackerPosition().latitude]">
      <button class="relative flex size-6" [style.color]="trackerPosition().color">
        <fast-svg name="tracker-mobile" size="100%" />
      </button>
    </mgl-marker>-->

    <mgl-marker #markerElement [lngLat]="[trackerPosition().longitude, trackerPosition().latitude]">
      <span class="relative flex size-3.5 transition-opacity" [class.opacity-30]="dimmed()">
        @if (floorTag(); as tag) {
          <span
            class="absolute left-1/2 top-full mt-1 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-1 text-[10px] font-bold leading-4 text-white"
            >{{ tag }}</span
          >
        }
        <!-- One ping per received position: the span is keyed on the position object, which
             the live feed replaces on every frame (even when the coordinates don't change). -->
        @for (p of [trackerPosition()]; track p) {
          <span
            class="animate-ping-once absolute inline-flex h-full w-full rounded-full opacity-75"
            [style.background-color]="trackerPosition().color"></span>
        }
        <span
          class="relative inline-flex size-3.5 rounded-full"
          [style.background-color]="trackerPosition().color"></span>
      </span>
    </mgl-marker>

    <mgl-popup [offset]="16" [marker]="markerElement" [closeButton]="false" [maxWidth]="'250'">
      <h4 class="text-lg font-semibold">{{ trackerPosition().name }}</h4>
      <div class="flex items-center gap-2">
        <i class="pi pi-map-marker" [style.color]="trackerPosition().color"></i>
        <span class="text-sm">
          <span class="font-bold">Lat:</span> {{ trackerPosition().latitude.toFixed(8) }},
          <span class="font-bold">Lng:</span> {{ trackerPosition().longitude.toFixed(8) }}
          <span class="font-bold">Alt:</span> {{ trackerPosition().altitude?.toFixed(8) || 'N/A' }}
        </span>
      </div>
    </mgl-popup>
  `,
})
export class MapTrackerMobileMarkerComponent {
  trackerPosition = input.required<TrackerPosition>();
  /**
   * Décalage écran (px) du marqueur posé au sol : le montre à son altitude sur une carte inclinée
   * avec un bâtiment 3D (ADR-017). `mgl-marker` ne relit pas son `offset` après création : il est
   * appliqué au marqueur MapLibre.
   */
  offset = input<[number, number] | null>(null);
  /** Estompé : autre étage que celui affiché. */
  dimmed = input<boolean>(false);
  /** Étiquette sous le marqueur (étage), ou `null`. */
  floorTag = input<string | null>(null);
  private readonly mglMarker = viewChild(MarkerComponent);

  constructor() {
    effect(() => {
      const offset = this.offset();
      const marker = this.mglMarker()?.markerInstance();
      applyMarkerOffset(marker, offset);
    });
  }

  @ViewChild('markerElement') markerElement!: MarkerComponent;
}
